/**
 * Shopify 公式ギフトラッピングパターン相当（/cart/update.js + カート属性）。
 * cart-items の AJAX 差し替え後も動くよう document へ委譲しています。
 */
(function () {
  function getConfig() {
    return document.getElementById('gift-wrapping-config');
  }

  function variantId() {
    const c = getConfig();
    return c && c.dataset.variantId ? String(c.dataset.variantId) : '';
  }

  function cartPageUrl() {
    const c = getConfig();
    if (c && c.dataset.cartUrl) return c.dataset.cartUrl;
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function updateUrl() {
    return window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
  }

  function redirectToCart() {
    window.location.href = cartPageUrl();
  }

  function setGiftWrap() {
    const id = variantId();
    if (!id) return;
    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: { [id]: 1 },
        attributes: { 'gift-wrapping': true },
      }),
    })
      .then(redirectToCart)
      .catch((e) => console.error(e));
  }

  function removeGiftWrap() {
    const id = variantId();
    if (!id) return;
    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: { [id]: 0 },
        attributes: { 'gift-wrapping': '', 'gift-note': '' },
      }),
    })
      .then(redirectToCart)
      .catch((e) => console.error(e));
  }

  function runSyncFromConfig() {
    const c = getConfig();
    if (!c) return;

    const itemsSize = parseInt(c.dataset.cartItemsSize || '0', 10);
    const wrapsInCart = parseInt(c.dataset.wrapsInCart || '0', 10);
    const attrSet = c.dataset.attrSet === 'true';

    if (itemsSize === 1 && wrapsInCart > 0) {
      removeGiftWrap();
      return;
    }
    if (wrapsInCart > 1) {
      setGiftWrap();
      return;
    }
    if (wrapsInCart > 0 && !attrSet) {
      setGiftWrap();
      return;
    }
    if (wrapsInCart === 0 && attrSet) {
      setGiftWrap();
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    runSyncFromConfig();

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== 'attributes[gift-wrapping]') return;
      if (!variantId()) return;
      if (target.checked) setGiftWrap();
      else removeGiftWrap();
    });

    const note = document.querySelector('#gift-note');
    if (note && 'value' in note) {
      note.addEventListener('change', () => {
        fetch(updateUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'gift-note': note.value },
          }),
        }).catch((e) => console.error(e));
      });
    }
  });

  window.Shopify = window.Shopify || {};
  window.Shopify.Cart = window.Shopify.Cart || {};
  window.Shopify.Cart.GiftWrap = {
    set: setGiftWrap,
    remove: removeGiftWrap,
  };
})();
